  // For multilangauge
  const enhanceCheckoutSection = document.getElementById('enhanceCheckoutSection');
  const addText = enhanceCheckoutSection.getAttribute('data-add');
  const addedtxt = enhanceCheckoutSection.getAttribute('data-added');
var EnhanceCartCheckout = function () {
  var self = this;

  
  this.initCartCount = function () {
    document.addEventListener("click", (e) => {
      const { target } = e;
      if (
        target.matches(".cart__number-next") ||
        target.closest(".cart__number-next")
      ) {
        e.preventDefault();
        const btnNext = target.classList.contains("cart__number-next")
          ? target
          : target.closest(".cart__number-next");
        const btnPrev = btnNext
          .closest(".cart__number")
          .querySelector(".cart__number-prev");
        const input = btnNext.closest(".cart__number").querySelector("input");
        initChangeValue(1, input, btnPrev);
      }

      if (
        target.matches(".cart__number-prev") ||
        target.closest(".cart__number-prev")
      ) {
        e.preventDefault();
        const btnPrev = target.classList.contains("cart__number-prev")
          ? target
          : target.closest(".cart__number-prev");
        const input = btnPrev.closest(".cart__number").querySelector("input");

        initChangeValue(-1, input, btnPrev);
      }
    });

    const initChangeValue = (counter, input, btnDec) => {
      const currentValue = parseInt(input.value) + parseInt(counter);
      input.value = currentValue;
      self.updateCart(input);
      if (btnDec) {
        if (currentValue <= 1) {
          btnDec.classList.add("disabled");
        } else {
          btnDec.classList.remove("disabled");
        }
      }
    };
    document.querySelectorAll(".cart__number").forEach((holder) => {
      var btnDec = holder.querySelector(".cart__number-prev");
      var btnInc = holder.querySelector(".cart__number-next");
      var input = holder.querySelector("input");
      var currentValue = parseInt(input.value);

      if (currentValue <= 1) {
        btnDec.classList.add("disabled");
      } else {
        btnDec.classList.remove("disabled");
      }
    });
  };
  this.init = function () {
    // let draftorder_id = undefined;
    // if (/[?&]id=/.test(location.search)) {
    //   let params = new URLSearchParams(window.location.search);
    //   draftorder_id = params.get("id");
    // }

    // CustomTrampolineATC.addToCart(draftorder_id)
    //   .then(function (res) {
    //     return res;
    //   })
    //   .catch(function (e) {
    //     console.log(e);
    //   })
    //   .then((res) => {
    //     fetch(window.Shopify.routes.root + "cart.js")
    //       .then((obj) => {
    //         return obj.json();
    //       })
    //       .catch((error) => {
    //         console.error("Error:", error);
    //       })
    //       .then((obj) => {
    //         window.history.replaceState(null, "", window.location.pathname);
    //         self.updateCheckoutBtn(obj);
    //         self.refreshCartItems(obj);
    //         obj.items.forEach((item, i) => {
    //           let prodList = document.querySelector(
    //             '.cart__list [data-product-id="' + item.product_id + '"]'
    //           );

    //           if (prodList != null) {
    //             labels = prodList
    //               .closest(".cart__item")
    //               .querySelector(".labels-wrap");

    //             prodList.querySelector(
    //               ".add-to-cart-wrap"
    //             ).innerHTML = `<div class="cart__number d-flex flex-wrap justify-content-end" action="#">
    //               <a href="#" class="cart__number-prev ${
    //                 parseInt(item.quantity) <= 1 ? "disabled" : ""
    //               }">
    //                 <svg xmlns="http://www.w3.org/2000/svg" width="10.183" height="1.994" viewBox="0 0 10.183 1.994">
    //                   <path id="Path_18" data-name="Path 18" d="M9.186,3.91H1A1,1,0,1,0,1,5.9H9.186a1,1,0,1,0,0-1.993Z"
    //                     transform="translate(0 -3.91)" fill="#fff"></path>
    //                 </svg>
    //               </a><input type="text" value="${
    //                 item.quantity
    //               }" class="qty-input">
    //               <a href="#" class="cart__number-next">
    //                 <svg xmlns="http://www.w3.org/2000/svg" width="10.183" height="10.183" viewBox="0 0 10.183 10.183">
    //                   <path id="Path_18" data-name="Path 18"
    //                     d="M9.186,3.91H6.047V1A1,1,0,1,0,4.053,1V3.91H1A1,1,0,1,0,1,5.9H4.053V9.186a1,1,0,0,0,1.994,0V5.9H9.186a1,1,0,1,0,0-1.993Z"
    //                     fill="#fff"></path>
    //                 </svg>
    //               </a>
    //             </div>`;
    //             if (prodList.querySelector(".select-wrapper") != null) {
    //               prodList.querySelector(".select-wrapper").style.visibility =
    //                 "hidden";
    //               prodList.setAttribute("data-variant-id", item.variant_id);
    //               prodList.querySelector(".select-wrapper select").value =
    //                 item.variant_title;
    //               prodList.querySelector(".select-wrapper select").onchange();
    //             }

    //             self.updatedBadge(obj, labels, item.product_id);
    //           }
    //         });
    //         self.updateCartItemMeta();
    //         // new InstallationUpdate();
    //       });
    //   });
    this.initCartCount(); //document.addEventListener('click', this.updateCart);
    document.addEventListener("click", this.deleteCartItem);
    document.addEventListener("click", this.addToCart);
  };
  this.updateCartItemMeta = function () {
    fetch("/cart?view=metafields.json")
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .then((obj) => {
        let elements = document.querySelectorAll(
          ".cart__list .label__included"
        );
        if (elements.length) {
          for (var i = 0; i < elements.length; i++) {
            elements[i].remove();
          }
        }
        let bundles_items = [];
        obj.items.forEach((item, index) => {
          if (item.including_installation) {
            bundles_items.push(item.sku);
          }
          let variant_item = document.querySelector(
            '.checkout-item-listing [data-variant="' +
              item.variant_id +
              '"] .stock-message'
          );
          let variant_cross_price = document.querySelector(
            '.checkout-item-listing [data-variant="' +
              item.variant_id +
              '"] .checkout__old-price'
          );
          if (variant_item) {
            variant_item.innerHTML =
              item.stock_message !== null
                ? item.stock_message_label + " " + item.stock_message
                : "In Stock";
          }
          // console.log(item);
          if (variant_cross_price && item.compare_at_price) {
            variant_cross_price.innerHTML = Shopify.formatMoney(
              item.compare_at_price
            );
          }

          if (item.choose_accessories !== null) {
            item.choose_accessories.forEach((cartItem, index) => {
              let product_id = cartItem.accessory.replace(
                "gid://shopify/Product/",
                ""
              );
              let labels = document.querySelector(
                '.cart__list [data-product-id="' + product_id + '"]'
              );
              if (labels !== null) {
                let _label_included = labels
                  .closest(".cart__item")
                  .querySelector(".labels-wrap");
                if (
                  labels
                    .closest(".cart__item")
                    .querySelector(".labels-wrap .label__included") == null
                ) {
                  _label_included.insertAdjacentHTML(
                    "beforeend",
                    '<span class="cart__label label label__included">INCLUDED</span>'
                  );
                }
              }
            });
          }
        });
        CheckoutPromo.upateBundleStatus(bundles_items);
      });
  };
  this.updateLineItem = function (formData) {
    return new Promise(function (resolve, reject) {
      fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);
        })
        .then((obj) => {
          resolve(obj);
        });
    });
  };

  this.addToCart = function (e) {
    if (e.target.classList.contains("btn-add")) {
      e.preventDefault();
      let current = e.target;
      let labels = e.target
        .closest(".cart__item")
        .querySelector(".labels-wrap");
      let productid =
        current.parentElement.parentElement.getAttribute("data-product-id");

      let formData = {
        items: [
          {
            id: current.parentElement.parentElement.getAttribute(
              "data-variant-id"
            ),
            quantity: 1,
            properties: {
              _PR_Page_ID:
                current.parentElement.parentElement.getAttribute("data-pr-id"),
            },
          },
        ],
      };

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);
        })
        .then((obj) => {
          if (
            current.parentElement.parentElement.querySelector(
              ".select-wrapper"
            ) != null
          ) {
            current.parentElement.parentElement.querySelector(
              ".select-wrapper"
            ).style.visibility = "hidden";
          }
          current.parentElement.innerHTML = `<div class="cart__number d-flex flex-wrap justify-content-end" action="#">
          <a href="#" class="cart__number-prev disabled">
            <svg xmlns="http://www.w3.org/2000/svg" width="10.183" height="1.994" viewBox="0 0 10.183 1.994">
              <path id="Path_18" data-name="Path 18" d="M9.186,3.91H1A1,1,0,1,0,1,5.9H9.186a1,1,0,1,0,0-1.993Z"
                transform="translate(0 -3.91)" fill="#fff"></path>
            </svg>
          </a><input type="text" value="1" class="qty-input">
          <a href="#" class="cart__number-next">
            <svg xmlns="http://www.w3.org/2000/svg" width="10.183" height="10.183" viewBox="0 0 10.183 10.183">
              <path id="Path_18" data-name="Path 18"
                d="M9.186,3.91H6.047V1A1,1,0,1,0,4.053,1V3.91H1A1,1,0,1,0,1,5.9H4.053V9.186a1,1,0,0,0,1.994,0V5.9H9.186a1,1,0,1,0,0-1.993Z"
                fill="#fff"></path>
            </svg>
          </a>
        </div>`;

          fetch(window.Shopify.routes.root + "cart.js")
            .then((obj) => {
              return obj.json();
            })
            .catch((error) => {
              console.error("Error:", error);
            })
            .then((obj) => {
              self.updateCheckoutBtn(obj);
              self.refreshCartItems(obj);
              self.updatedBadge(obj, labels, productid);
              self.updateCartItemMeta();
            });
        });
    }
  };

  this.updatedBadge = function (obj, labels, productid) {
    let _label_added = labels.querySelector(".label__added");
    let _count = obj.items.reduce(
      (accumulator, item) =>
        item.product_id == productid
          ? accumulator + item.quantity
          : accumulator,
      0
    );
    if (typeof _label_added != "undefined" && _label_added != null)
      _label_added.remove();
    if (_count > 0) {
      labels.insertAdjacentHTML(
        "beforeend",
        `<span class="cart__label label bg-success label__added">${_count} ${addedtxt}</span>`
      );
    }
  };

  this.updateCart = function (input) {
    let _cart_info = input.closest(".cart__text-info");
    if (_cart_info == null) {
      _cart_info = input.closest(".cart-info-box");
    }

    let labels = input.closest(".cart__item").querySelector(".labels-wrap");
    let productid = _cart_info.getAttribute("data-product-id");
    let variantid = _cart_info.getAttribute("data-variant-id");
    let qty = parseInt(_cart_info.querySelector(".qty-input").value);
    let formData = {
      updates: {},
    };
    formData.updates[variantid] = qty;

    self.updateLineItem(formData).then((obj) => {
      self.updateCheckoutBtn(obj);
      self.refreshCartItems(obj);
      self.updatedBadge(obj, labels, productid);
      self.updateCartItemMeta();
      // let installationProduct = "installation";
      // new InstallationUpdate(false, false, installationProduct);
    });
  };
  this.updateCheckoutBtn = function (obj) {
    if (obj.items.length == 0) {
      document
        .querySelector(".btn-checkout")
        ?.setAttribute("disabled", "disabled");
    } else {
      document.querySelector(".btn-checkout")?.removeAttribute("disabled");
    }
  };
  this.deleteCartItem = function (e) {
    if (
      e.target.classList.contains("checkout__del") ||
      e.target.parentElement.classList.contains("checkout__del") ||
      e.target.parentElement.parentElement.classList.contains("checkout__del")
    ) {
      e.preventDefault();
      let variant_id = e.target
        .closest(".checkout__item")
        .getAttribute("data-variant");

      let sku = e.target.closest(".checkout__item").getAttribute("data-sku");

      let formData = {
        updates: {},
      };
      formData.updates[variant_id] = 0;
      let newCustomToolItems = 0;
      // if (
      //   CUSTOMTRAMPOLINES.includes(sku) &&
      //   document.querySelector(".checkout__list").hasChildNodes()
      // ) {
      //   document
      //     .querySelectorAll(".checkout__list .checkout__item")
      //     .forEach((item, index) => {
      //       let csku = item.getAttribute("data-sku");
      //       let cqty = item.querySelector(".checkout__num").innerHTML;
      //       if (CUSTOMTRAMPOLINES.includes(csku)) {
      //         newCustomToolItems += parseInt(cqty);
      //       }
      //     });
      //   let current_qty = e.target
      //     .closest(".checkout__item")
      //     .querySelector(".checkout__num").innerHTML;
      //   newCustomToolItems = newCustomToolItems - parseInt(current_qty);
      //   formData.updates[customizationFeeID] = newCustomToolItems;
      // }

      self.updateLineItem(formData).then((obj) => {
        self.updateCheckoutBtn(obj);
        self.updatePromocode(obj);
        let _cart_atc = document.querySelector(
          '.cart__list [data-variant-id="' + variant_id + '"]'
        );
         
        if (_cart_atc !== null) {
          let productid = _cart_atc.getAttribute("data-product-id");
          let labels = _cart_atc
            .closest(".cart__item")
            .querySelector(".labels-wrap");
          // console.log(_cart_atc);
          _cart_atc.querySelector(
            ".add-to-cart-wrap"
          ).innerHTML = `<a href="#" class="btn btn-primary btn-add">${addText}</a>`;
          if (_cart_atc.querySelector(".select-wrapper") != null) {
            _cart_atc.querySelector(".select-wrapper").style.visibility =
              "visible";
          }
          self.updatedBadge(obj, labels, productid);
        }
        self.updateCartItemMeta();
        let installationProduct = "installation";
        // new InstallationUpdate(false, false, installationProduct);
        e.target.closest(".checkout__item").remove();

        // remove installation item from checkout sidebar start
        let trampolinesLength = document.querySelectorAll(
          '.checkout__list .checkout__item[data-type="trampoline"], .checkout__list .checkout__item[data-type="Custom Trampoline"]'
        ).length;
        let installationItem = document.querySelector(
          '.checkout__list .checkout__item[data-type="installation"]'
        );
        if (trampolinesLength < 1) {
          installationItem?.remove();
          document
            .querySelector(".professional-install.cart__selected")
            ?.classList.remove("cart__selected");
        }
        if (installationItem == null) {
          let originalprice = document
            .querySelector(".professional-install.cart__selected")
            ?.querySelector(".price strong del")?.innerHTML;
          if (originalprice != null) {
            document.querySelector(
              ".professional-install.cart__selected .price strong"
            ).innerHTML = originalprice;
          }
          document
            .querySelector(".professional-install.cart__selected")
            ?.classList.remove("cart__selected");
        }

        document.querySelector(".checkout__subtotal-price").innerHTML =
          Shopify.formatMoney(obj.total_price);// + " " + obj.currency;
        document.querySelector(".checkout__total-price .price").innerHTML =
          Shopify.formatMoney(obj.total_price);
        document.querySelector(
          ".checkout__total .checkout__total-price .price"
        ).innerHTML = Shopify.formatMoney(obj.total_price);
      });
    }
  };

  this.updatePromocode = function (obj) {
    CheckoutPromo.init(obj.items);
    if (localStorage.getItem("discountCode")) {
      EnhancePromocode.applyDiscount(localStorage.getItem("discountCode"), false);
    }
  };

  this.refreshCartItems = function (cart) {
    document.querySelector(".checkout__subtotal-price").innerHTML =
      Shopify.formatMoney(cart.total_price);// + " " + cart.currency;
    document.querySelector(".checkout__total-price .price").innerHTML =
      Shopify.formatMoney(cart.total_price);
    document.querySelector(
      ".checkout__total .checkout__total-price .price"
    ).innerHTML = Shopify.formatMoney(cart.total_price);
    self.updatePromocode(cart);
    cart.items.forEach((item, index) => {
      let listing = document.querySelector(
        '.checkout-item-listing [data-variant="' + item.variant_id + '"]'
      );
      if (listing !== null) {
        listing.querySelector(".checkout__price .price").innerHTML =
          Shopify.formatMoney(item.final_line_price);
        listing.querySelector(".checkout__img .checkout__num").innerHTML =
          item.quantity;
        if( listing.querySelector(".checkout__qty select") ) {
          listing.querySelector(".checkout__qty select").value = item.quantity;
        }
        
      } else {
        let deletebtn = `<a href="#" class="checkout__del">
        <svg viewBox="0 0 13.5 14.291">
          <path id="svgexport-13"
            d="M12.336,5.33,11.849,14.4a.635.635,0,0,1-.628.6H3.278a.635.635,0,0,1-.628-.6L2.164,5.33A.629.629,0,1,1,3.42,5.267l.455,8.477h6.766L11.1,5.267a.621.621,0,1,1,1.24.063ZM14,3.23a.63.63,0,0,1-.628.628H1.128a.628.628,0,0,1,0-1.256H4.581V1.186a.454.454,0,0,1,.5-.471H9.417a.454.454,0,0,1,.5.471V2.6H13.37a.63.63,0,0,1,.63.628ZM5.68,2.6H8.82V1.815H5.68Zm.267,10.2a.587.587,0,0,0,.549-.6L6.34,5.424a.56.56,0,0,0-.565-.549.537.537,0,0,0-.534.565l.157,6.8a.57.57,0,0,0,.549.562Zm2.59,0a.556.556,0,0,0,.549-.549l.157-6.781a.55.55,0,0,0-1.1-.031l-.157,6.781a.553.553,0,0,0,.549.581Z"
            transform="translate(-0.5 -0.712)" fill="#626262" stroke="#cfd2d5" stroke-width="0"></path>
        </svg>
      </a>`;
        let _image_url = item.featured_image.url.imgURL("x190");
        if (item.product_type == "Custom Trampoline") {
          _image_url = item.properties._image_url;
        }

        let _html = `<div class="checkout__item" data-variant="${
          item.variant_id
        }" data-sku="${item.sku}">
          <div class="checkout__wrap">
            <div class="checkout__img">
              <span class="checkout__num">${item.quantity}</span>
              <a href="${item.url}">
                <img class="cart__image" src="${_image_url}" loading="lazy" alt="${
          item.featured_image.alt
        }" data-cart-item-image>
              </a>
            </div>
            <div class="checkout__text">
              <span class="checkout__title">${item.title}</span>
              <p class="stock-message"></p>
              <div class="discount-message"></div>
            </div>
          </div>
          <div class="checkout__qty">
            <span class="checkout__qty">
              <label for="checkout_qty1" class="d-inline-block mr-1">Qty:</label>
              <div class="select-holder">
                <select
                  class="js-choices"
                >
                    ${[1, 2, 3, 4, 5]
                      .map(
                        (i) => `
                    <option value="${i}" ${
                          item.quantity == i ? "selected" : ""
                        }>
                      ${i}
                    </option>`
                      )
                      .join("")}
                </select>
              </div>
            </span>
          </div>
          <div class="checkout__price">
            <span class="checkout__old-price"></span>
            <div class="position-relative checkout__new">
              <span class="price">${Shopify.formatMoney(item.final_line_price)}</span>
             ${
               item.handle != "customization-fee" &&
               item.handle != "customization-fee_new"
                 ? deletebtn
                 : ""
             }
            </div>
          </div>
        </div>`;
        document
          .querySelector(".checkout-item-listing .checkout__list")
          .insertAdjacentHTML("beforeend", _html);
      }
    });
    updateSidebarCart();
  };

  this.init();
};
new EnhanceCartCheckout();

function updateSidebarCart() {
  var quantityInputs = document.querySelectorAll(".checkout__qty select");

  // Attach event listener to each quantity input field

  quantityInputs.forEach(function (quantityInput) {
    quantityInput.addEventListener("change", function () {
      // Get the new quantity value

      var newQuantity = this.value;

      //console.log('newQuantity', newQuantity);

      // Get the variant ID

      var parentProduct = this.closest(".checkout__item");

      var variantId = parentProduct.getAttribute("data-variant");

      // Update the cart

      updateCart(variantId, newQuantity);
    });
  });
}

// Function to update the cart

function updateCart(variantId, newQuantity) {
  // Create a form data object
  var formData = new FormData();
  formData.append("updates[" + variantId + "]", newQuantity);
  // Make a POST request to Shopify's cart/update.js endpoint

  fetch("/cart/update.js", {
    method: "POST",
    body: formData,
  })
    .then((response) => response.json())
    .then((data) => {
      // Update cart display
      document.querySelector(".checkout__subtotal-price").innerHTML =
        Shopify.formatMoney(data.total_price);
      document.querySelector(".checkout__total-price .price").innerHTML =
        Shopify.formatMoney(data.total_price);
      document.querySelector(
        ".checkout__total .checkout__total-price .price"
      ).innerHTML = Shopify.formatMoney(data.total_price);

      let checkoutNum = document.querySelector(
        `[data-variant="${variantId}"] .checkout__num`
      );

      let leftSideQty = document.querySelector(
        `.cart__text-info[data-variant-id="${variantId}"] .qty-input`
      );

      if (leftSideQty != null) {
        leftSideQty.value = newQuantity;
        if (newQuantity > 1) {
          document
            .querySelector(
              `.cart__text-info[data-variant-id="${variantId}"] .cart__number-prev`
            )
            .classList.remove("disabled");
        } else {
          document
            .querySelector(
              `.cart__text-info[data-variant-id="${variantId}"] .cart__number-prev`
            )
            .classList.add("disabled");
        }
      }

      let updateProduct = document.querySelector(
        `.cart__text-info[data-variant-id="${variantId}"]`
      );
      if (updateProduct != null) {
        updateProduct
          .closest(".cart__item")
          .querySelector(".cart__label").innerHTML = `${newQuantity}  ${addedText}`;
      }
      checkoutNum.textContent = newQuantity;
      data.items.forEach(function (item) {
        if (item.id == variantId) {
          let price = item.final_line_price;
          document.querySelector(
            `[data-variant="${variantId}"] .price`
          ).textContent = Shopify.formatMoney(price);
        }
      });
    })

    .catch((error) => {
      console.error("Error updating cart:", error);
    });
}

document.addEventListener("DOMContentLoaded", function () {
  updateSidebarCart();
  document
    .querySelector(".btn-checkout")
    ?.addEventListener("click", function () {
      this.classList.add("disbaled", "loading");
    });
  document
    .querySelector(".step1 .btn-primary")
    ?.addEventListener("click", function () {
      this.classList.add("disbaled", "loading");
    });
});

window.addEventListener("pageshow", function (event) {
  var historyTraversal =
    event.persisted ||
    (typeof window.performance != "undefined" &&
      window.performance.navigation.type === 2);
  if (historyTraversal) {
    // Handle page restore.
    window.location.reload();
  }
});
